import {
    parseISO,
    isToday,
    isYesterday,
    isThisWeek,
    isThisMonth
} from "date-fns";

import { NotificationGroup } from "./types";

export const groupNotificationsByTime = (
    notificationGroups: NotificationGroup[]
) => {
    const today: NotificationGroup[] = [];
    const yesterday: NotificationGroup[] = [];
    const thisWeek: NotificationGroup[] = [];
    const thisMonth: NotificationGroup[] = [];
    const older: NotificationGroup[] = [];

    notificationGroups.forEach((group) => {
        // Use the first notification's timestamp to determine the group's time bucket
        const firstNotification = group.notifications[0];
        if (firstNotification) {
            const date = parseISO(firstNotification.timestamp);
            if (isToday(date)) {
                today.push(group);
            } else if (isYesterday(date)) {
                yesterday.push(group);
            } else if (isThisWeek(date, { weekStartsOn: 1 })) {
                thisWeek.push(group);
            } else if (isThisMonth(date)) {
                thisMonth.push(group);
            } else {
                older.push(group);
            }
        }
    });

    return {
        today,
        yesterday,
        thisWeek,
        thisMonth,
        older
    };
};
